import { InjectionToken } from "@angular/core";

export const TAB_MENU_NAME_INJECTION = new InjectionToken<string>('', { providedIn: 'root',  factory: () => '' } );
export const TIENG_VIET = /^([A-ZỲỌÁẦẢẤỜỄÀẠẰỆẾÝỘẬỐŨỨĨÕÚỮỊỖÌỀỂẨỚẶÒÙỒỢÃỤỦÍỸẮẪỰỈỎỪỶỞÓÉỬỴẲẸÈẼỔẴẺỠƠÔƯĂÊÂĐ|a-zỳọáầảấờễàạằệếýộậốũứĩõúữịỗìềểẩớặòùồợãụủíỹắẫựỉỏừỷởóéửỵẳẹèẽổẵẻỡơôưăêâđ\s\n0-9])+$/
export const TIENG_VIET_ONLY = /^([A-ZỲỌÁẦẢẤỜỄÀẠẰỆẾÝỘẬỐŨỨĨÕÚỮỊỖÌỀỂẨỚẶÒÙỒỢÃỤỦÍỸẮẪỰỈỎỪỶỞÓÉỬỴẲẸÈẼỔẴẺỠƠÔƯĂÊÂĐ|a-zỳọáầảấờễàạằệếýộậốũứĩõúữịỗìềểẩớặòùồợãụủíỹắẫựỉỏừỷởóéửỵẳẹèẽổẵẻỡơôưăêâđ\s\n])+$/
export const VN_REGEX = /^([A-ZỲỌÁẦẢẤỜỄÀẠẰỆẾÝỘẬỐŨỨĨÕÚỮỊỖÌỀỂẨỚẶÒÙỒỢÃỤỦÍỸẮẪỰỈỎỪỶỞÓÉỬỴẲẸÈẼỔẴẺỠƠÔƯĂÊÂĐ|a-zỳọáầảấờễàạằệếýộậốũứĩõúữịỗìềểẩớặòùồợãụủíỹắẫựỉỏừỷởóéửỵẳẹèẽổẵẻỡơôưăêâđ\s\n0-9,.:()?\/])+$/
export const OPTIONS_GENDER = [{value: 1, label: 'Nam'}, {value: 0, label: 'Nữ'}, {value: 2, label: 'Khác'}]
export const OPTIONS_CUSTOMER = [{value: 1, label: 'Doanh nghiệp'}, {value: 0, label: 'Cá nhân'}]
export const OPTIONS_LANGUAGE = [{value: 0, label: 'Tiếng Việt'}, {value: 1, label: 'Tiếng anh'}]
export const OPTION_DATA_TYPE = [
  {value: 'String', label: "String"},
  {value: 'Date', label: "Date"},
  {value: 'boolean', label: "Boolean"},
  {value: 'Double', label: "Double"},
  {value: 'Timestamp', label: "Timestamp"},
  {value: 'int', label: "Int"},
  {value: 'Long', label: "Long"},
]
export const OPTION_APP_CONFIG = [
  {value: 'app_config', label: "APP_CONFIG"},
]
export const FILE_ACCEPT = '.xlsx,.xls,.doc,.docx,.pdf,.rar,.zip,.mp3,.mp4,image/*';
export const FILE_TYPE_ACCEPT = ['image/png', 'image/jpeg', 'image/gif', 'image/bmp', 'application/pdf', 'application/msword',
'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet','application/vnd.ms-excel',
'audio/mpeg','video/mp4','application/x-zip','application/x-zip-compressed','application/x-7z-compressed',
'application/vnd.rar','application/x-rar','application/x-rar-compressed','application/vnd.comicbook-rar'];

export const DATA_TICKET = new InjectionToken<any>('', { providedIn: 'root', factory: () => '' });
